import { Div } from "@tblabs/truffle";
import { appendable } from "@tblabs/truffle/Core/appendable";


export class SmallHeader extends Div
{
    constructor(text: string)
    {
        super();
        this.Style(`font-size: 16px; 
            color: #1e87f0; 
            text-align:left; 
            padding: 8px; 
            margin-top: 16px; 
            padding: 4px 16px;
            border-top: 2px dashed #1e87f044;`);
        this.Text(text);
    }
}

export class BigHeader extends Div
{
    constructor(text: string, cmps?: appendable[])
    {
        super();
        this.Style(`font-size: 22px; 
            color: #1e87f0; 
            background: #effbff;
            text-align:left; 
            padding: 8px; 
            margin-top: 32px;
            padding: 4px 16px;
            border-top: 4px solid #1e87f0;`);
        this.Append(
            text,
            cmps && new Div().Append(...cmps));
    }
}
